import { ItemStatus, ItemCategory, ItemSeason } from "src/shared/backend-api.types";
import { Item } from "src/services/item/item.interface";

export const ItemStatusDisplay: Record<ItemStatus, string> = {
  inStaging: "In staging",
  inStorage: "In storage",
  inTrip: "In trip",
  inVehicle: "In vehicle",
  onboarding: "Onboarding",
  reclaimed: "Reclaimed",
};

export const ItemStatusValues: ItemStatus[] = [
  "inStaging",
  "inStorage",
  "inTrip",
  "inVehicle",
  "onboarding",
  "reclaimed",
];

export const EditableItemStatusValues: ItemStatus[] = ItemStatusValues.filter((value) => value !== "reclaimed");

export const ItemCategoryDisplay: Record<ItemCategory, string> = {
  bike: "Bike",
  bootBag: "Boot Bag",
  boots: "Boots",
  doubleSkiBag: "Double Ski/Snowboard Bag",
  golfBag: "Golf Bag",
  largeBag: "Large Bag",
  other: "Other",
  oversizeBag: "Oversize Bag",
  poles: "Poles",
  singleSkiBag: "Single Ski Bag",
  skis: "Skis",
  smallBag: "Small Bag",
  sportsGear: "Sports Gear",
  storageBin: "Storage Bin",
};

export const ItemCategoryValues: ItemCategory[] = [
  "bike",
  "bootBag",
  "boots",
  "doubleSkiBag",
  "golfBag",
  "largeBag",
  "other",
  "oversizeBag",
  "poles",
  "singleSkiBag",
  "skis",
  "smallBag",
  "sportsGear",
  "storageBin",
];

export const ItemSeasonDisplay: Record<ItemSeason, string> = {
  autumn: "Autumn",
  spring: "Spring",
  summer: "Summer",
  winter: "Winter",
};

export const ItemSeasonValues: ItemSeason[] = ["autumn", "spring", "summer", "winter"];

export function itemCategoryToString(category: ItemCategory | null | undefined): string {
  return (category && ItemCategoryDisplay[category]) || "No category";
}

export function itemNameToString(item: Pick<Item, "name"> | undefined): string | undefined {
  return item?.name?.trim() || undefined;
}

export function itemToString(item: Pick<Item, "category" | "name">): string {
  return itemNameToString(item) ?? itemCategoryToString(item.category);
}
